import { keepOneOrLine, keepOnePercentOrLine } from '@/utils/utils';
import { V2WaterMapDataTrendPostResponse } from '@maxtropy/device-customer-apis-v2';
import dayjs from 'dayjs';
import { DateTypeByWater } from '../..';
import { formatName, normalizeSquareListUnit } from '@/pages/WgqAllMaps/utils';

export const getChartOption = (data?: V2WaterMapDataTrendPostResponse, timeResolution?: DateTypeByWater) => {
  const { normalizedData, unit } = normalizeSquareListUnit(data?.list, {
    valueKey: 'value',
    threshold: 10000,
    baseUnit: 'm³',
  });
  const formatStr = timeResolution === DateTypeByWater.MONTH ? 'MM-DD' : 'M月';

  return {
    color: ['#16DD8E', '#FFCB47'],
    backgroundColor: 'transparent',
    grid: {
      left: 10,
      right: 10,
      top: 30,
      bottom: 10,
      containLabel: true,
    },
    legend: {
      top: 0,
      right: 10,
      icon: 'rect',
      itemWidth: 12,
      itemHeight: 12,
    },
    tooltip: {
      formatter: (items: any) => {
        let { axisValue } = items[0];
        let firstStr = dayjs(axisValue).format(formatStr);
        let otherStr = '';
        let str = '';

        // 截断 name，最多 15 个字符
        // let shortName = (name ?? []).length > 12 ? name?.slice(0, 12) + '...' : name;

        items.forEach((item: any) => {
          const { data, marker, seriesName } = item;
          otherStr += `<div style="margin-top:8px;width:280px;"><div style="display:flex;justify-content:space-between;align-items:center;"><div style="width:100px"><span>${marker}</span>${seriesName}</div>
          <div>${keepOneOrLine(data.value)}（${unit}）</div><div>${data.percent}%</div></div>`;
          str = firstStr + otherStr;
        });

        return str;
      },
    },
    xAxis: [
      {
        type: 'category',
        data: (normalizedData?.[0]?.squareList ?? []).map(a => a?.time),
        axisLabel: {
          formatter: function (e: number) {
            return dayjs(e, timeResolution === DateTypeByWater.MONTH ? 'YYYY-MM-DD' : 'YYYY-MM').format(formatStr);
          },
          hideOverlap: true,
          showMinLabel: true,
          showMaxLabel: true,
        },
        boundaryGap: true,
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: `总用量（${unit}）`,
      },
    ],
    series: normalizedData?.map(item => ({
      name: formatName(item.energyMediumName),
      type: 'bar',
      data: (item?.squareList ?? []).map(item => ({
        value: item.value,
        percent: keepOnePercentOrLine(item.proportion),
      })),
    })),
  };
};
export const getChartNoWorkingOption = (data?: V2WaterMapDataTrendPostResponse, timeResolution?: DateTypeByWater) => {
  const formatStr = timeResolution === DateTypeByWater.MONTH ? 'MM-DD' : 'M月';

  const { normalizedData, unit } = normalizeSquareListUnit(data?.list, {
    valueKey: 'value',
    threshold: 10000,
    baseUnit: 'm³',
  });

  console.log('转换后1111', unit, normalizedData);

  return {
    color: ['#16DD8E', '#FFCB47'],
    backgroundColor: 'transparent',
    grid: {
      left: 30,
      right: 10,
      top: 30,
      bottom: 10,
      containLabel: true,
    },
    legend: {
      top: 0,
      right: 10,
      icon: 'rect',
      itemWidth: 12,
      itemHeight: 12,
    },
    tooltip: {
      formatter: (items: any) => {
        let { axisValue } = items[0];
        // let firstStr = dayjs(axisValue).format(formatStr);
        let otherStr = '';
        let str = '';

        // 截断 name，最多 15 个字符
        // let shortName = (name ?? []).length > 12 ? name?.slice(0, 12) + '...' : name;

        items.forEach((item: any) => {
          const { data, marker, seriesName } = item;
          otherStr += `<div style="margin-top:8px;width:280px;"><div style="display:flex;justify-content:space-between;align-items:center;"><div style="width:100px"><span>${marker}</span>${seriesName}</div>
         <div>${keepOneOrLine(data.value)}（${unit}）</div><div>${data.percent}%</div></div>`;
          str = axisValue + otherStr;
        });

        return str;
      },
    },
    xAxis: [
      {
        type: 'category',
        data: (normalizedData?.[0]?.squareList ?? []).map(a => a?.time),
        axisLabel: {
          formatter: function (e: number) {
            return dayjs(e, timeResolution === DateTypeByWater.MONTH ? 'YYYY-MM-DD' : 'YYYY-MM').format(formatStr);
          },
          hideOverlap: true,
          showMinLabel: true,
          showMaxLabel: true,
        },
        boundaryGap: true, // 或直接删掉
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: `非生产时段-用量（${unit}）`,
        nameTextStyle: {
          fontSize: 14,
          align: 'left',
        },
      },
    ],
    series: normalizedData?.map(item => ({
      name: formatName(item.energyMediumName),
      type: 'bar',
      data: (item?.squareList ?? []).map(item => ({
        value: item?.periodWorkTimeList?.[0]?.value,
        percent: keepOnePercentOrLine(item?.periodWorkTimeList?.[0]?.proportion),
      })),
    })),
  };
};
